/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { potentialTraningsExport } from "actions";
import PotentialTraining from "components/widgets/training/PotentialTraining";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class PotentialTrainings extends Component {
  state = {
    filteredTrainingsData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    dataFetched: false,
    sort_by: "trName", // training name by default
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredTrainingsData: this.props.data.trainings });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({ filteredTrainingsData: this.props.data.trainings });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredTrainingsData: this.props.data.trainings.filter((item) => {
          return (
            Helpers.getTurkishCharaterFixedList(item.training.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.employee.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            )
          );
        }),
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  handleExport = () => {
    this.props.potentialTraningsExport(
      this.state.filterTerm,
      this.onBegin,
      this.onExportSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onExportSuccess = (res, fname) => {
    this.props.onProcessEnd();
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fname);
    document.body.appendChild(link);
    link.click();
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredTrainingsData?.length > 0
              ? this.state.filteredTrainingsData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        <button className="export-button" onClick={this.handleExport}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button>
      </div>
    );
  };

  trType = "";
  trTraining = "";
  trEmployee = "";
  trRole = "";
  trServiceType = "";
  trPreRequisitesCompleted = "";
  trTargetedPosition = "";
  trPositionTraining = "";
  trPosition = "";
  trQualifications = "";
  trFormattedMethod = "";
  trTrainingWeight = "";
  trTrainingFutureWeight = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trTraining = "";
    this.trEmployee = "";
    this.trRole = "";
    this.trServiceType = "";
    this.trPreRequisitesCompleted = "";
    this.trTargetedPosition = "";
    this.trPositionTraining = "";
    this.trPosition = "";
    this.trQualifications = "";
    this.trFormattedMethod = "";
    this.trTrainingWeight = "";
    this.trTrainingFutureWeight = "";

    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trTraining":
        this.trTraining = `_${this.state.sort_dir}`;
        break;
      case "trEmployee":
        this.trEmployee = `_${this.state.sort_dir}`;
        break;
      case "trRole":
        this.trRole = `_${this.state.sort_dir}`;
        break;
      case "trServiceType":
        this.trServiceType = `_${this.state.sort_dir}`;
        break;
      case "trPreRequisitesCompleted":
        this.trPreRequisitesCompleted = `_${this.state.sort_dir}`;
        break;
      case "trTargetedPosition":
        this.trTargetedPosition = `_${this.state.sort_dir}`;
        break;
      case "trPositionTraining":
        this.trPositionTraining = `_${this.state.sort_dir}`;
        break;
      case "trPosition":
        this.trPosition = `_${this.state.sort_dir}`;
        break;
      case "trQualifications":
        this.trQualifications = `_${this.state.sort_dir}`;
        break;
      case "trFormattedMethod":
        this.trFormattedMethod = `_${this.state.sort_dir}`;
        break;
      case "trTrainingWeight":
        this.trTrainingWeight = `_${this.state.sort_dir}`;
        break;
      case "trTrainingFutureWeight":
        this.trTrainingFutureWeight = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredTrainingsData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trType":
          return this.state.sort_dir === "desc"
            ? a.method?.label.localeCompare(b.method?.label)
            : b.method?.label.localeCompare(a.method?.label);
        case "trTraining":
          return this.state.sort_dir === "desc"
            ? a.training?.name.localeCompare(b.training?.name)
            : b.training?.name.localeCompare(a.training?.name);
        case "trEmployee":
          return this.state.sort_dir === "desc"
            ? a.employee?.name.localeCompare(b.employee?.name)
            : b.employee?.name.localeCompare(a.employee?.name);
        case "trRole":
          return this.state.sort_dir === "desc"
            ? a.role?.name.localeCompare(b.role?.name)
            : b.role?.name.localeCompare(a.role?.name);
        case "trServiceType":
          return this.state.sort_dir === "desc"
            ? a.serviceType?.label.localeCompare(b.serviceType?.label)
            : b.serviceType?.label.localeCompare(a.serviceType?.label);
        case "trPreRequisitesCompleted":
          return this.state.sort_dir === "desc"
            ? a.preRequisitesCompleted - b.preRequisitesCompleted
            : b.preRequisitesCompleted - a.preRequisitesCompleted;
        case "trTargetedPosition":
          return this.state.sort_dir === "desc"
            ? a.targetedPosition - b.targetedPosition
            : b.targetedPosition - a.targetedPosition;
        case "trPositionTraining":
          return this.state.sort_dir === "desc"
            ? a.positionTraining - b.positionTraining
            : b.positionTraining - a.positionTraining;
        case "trPosition":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        case "trQualifications":
          return this.state.sort_dir === "desc"
            ? a.qualifications - b.qualifications
            : b.qualifications - a.qualifications;
        case "trFormattedMethod":
          return this.state.sort_dir === "desc"
            ? a.formattedMethod.localeCompare(b.formattedMethod)
            : b.formattedMethod.localeCompare(a.formattedMethod);
        case "trTrainingWeight":
          return this.state.sort_dir === "desc"
            ? (a.trainingWeight ?? 0) - (b.trainingWeight ?? 0)
            : (b.trainingWeight ?? 0) - (a.trainingWeight ?? 0);
        case "trTrainingFutureWeight":
          return this.state.sort_dir === "desc"
            ? (a.trainingFutureWeight ?? 0) - (b.trainingFutureWeight ?? 0)
            : (b.trainingFutureWeight ?? 0) - (a.trainingFutureWeight ?? 0);
        default:
          return this.state.sort_dir === "desc"
            ? a.training?.name.localeCompare(b.training?.name)
            : b.training?.name.localeCompare(a.training?.name);
      }
    });

    return sorted.slice(start, end).map((t) => {
      return (
        <PotentialTraining
          key={t.key}
          t={t}
          employeeCode={this.props.data.employeeCode}
        />
      );
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="kayitliEgitimler"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive tgE dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trType")}
                  className={`all sorting${this.trType}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Tür">10114</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trTraining")}
                  className={`all sorting${this.trTraining}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Eğitim Adı">10115</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trEmployee")}
                    className={`desktop sorting${this.trEmployee}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Çalışan">10070</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trRole")}
                    className={`desktop sorting${this.trRole}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Rol">10407</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trServiceType")}
                    className={`desktop sorting${this.trServiceType}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Departman">
                        potentialtrainings_departman
                      </Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPreRequisitesCompleted")}
                    className={`desktop sorting${this.trPreRequisitesCompleted}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Önşart Tamamlanma">10409</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trTargetedPosition")}
                    className={`desktop sorting${this.trTargetedPosition}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Hedeflenen Pozisyon">10500</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPositionTraining")}
                    className={`desktop sorting${this.trPositionTraining}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Pozisyon Eğitimi">10501</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPosition")}
                    className={`desktop sorting${this.trPosition}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Pozisyon">10502</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trQualification")}
                    className={`desktop sorting${this.trQualification}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Yeterlilik">10503</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trFormattedMethod")}
                    className={`desktop sorting${this.trFormattedMethod}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Tür">10114</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trTrainingWeight")}
                    className={`desktop sorting${this.trTrainingWeight}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Mevcut ETO">10172</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trTrainingFutureWeight")}
                    className={`desktop sorting${this.trTrainingFutureWeight}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Gelecek ETO">10173</Trans>
                    </div>
                  </th>
                  <th className="none"></th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ application }) => {
  return {
    application,
  };
};

export default connect(mapStateToProps, { potentialTraningsExport })(
  containsLongRunningProcess(requireAuth(PotentialTrainings))
);
